<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-buttons slot="start">
          <ion-button @click="closeImport">Close</ion-button>
        </ion-buttons>
        <ion-title>Import Form</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding> </ion-content>
  </div>
</template>

<script>
import Helpers from "../mixins/Helpers";
export default {
  name: "form-import",
  mixins: [Helpers],
  components: {},
  props: ["form"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    closeImport() {
      this.hideModal();
    }
  }
};
</script>

<style scoped></style>
